import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@ontruck/orc';
import { isEmpty } from 'utils/types';
import { isEmailValid, urls, getConfig } from 'utils/auth';
import api from 'api';
import DefaultButton from 'refactored/ui/form/defaultButton';
class LoginRecoverForm extends React.Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    this.state = {
      hasToken: (match && match.params && match.params.recoverToken) || false,
      isTokenValid: true,
      password: '',
      credential: '',
      error: false,
      fetching: false,
      success: false,
      errorField: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.recoverToken) {
      this.checkToken({ token: match.params.recoverToken });
    } else {
      this.setState({ isTokenValid: false });
    }
  }

  checkToken = async ({ token }) => {
    try {
      await api.post(urls.check, { token });
      this.setState({ isTokenValid: true });
    } catch (err) {
      this.setState({ isTokenValid: false });
    }
  };

  handleSubmitRequest = async (e) => {
    const { credential } = this.state;
    e.preventDefault();
    if (isEmpty(credential) || !isEmailValid(credential)) {
      this.setState({ errorField: true });
      return;
    }
    try {
      this.setState({ fetching: true });
      await api.post(urls.request, { credential });
      this.setState({ success: true });
    } catch (err) {
      this.setState({ error: true });
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleSubmitReset = async (e) => {
    const { password } = this.state;
    e.preventDefault();
    if (isEmpty(password)) {
      this.setState({ errorField: true });
      return;
    }
    const { match, login } = this.props;
    const token = (match && match.params && match.params.recoverToken) || '';
    try {
      this.setState({ fetching: true });
      const {
        data: { username },
      } = await api.post(urls.reset, { password, token });
      login({ username, password });
    } catch (err) {
      this.setState({ error: true });
    } finally {
      this.setState({ fetching: false });
    }
  };

  setValue = (_, { name, value }) => {
    this.setState({ [name]: value, errorField: false });
  };

  getTitleClassNames = ({ hasToken, isTokenValid, error, success }) =>
    `title ${(hasToken && !isTokenValid) || error ? 'error' : ''} ${
      success ? 'success' : ''
    }`;

  render() {
    const { className, t } = this.props;
    const {
      error,
      credential,
      password,
      hasToken,
      isTokenValid,
      success,
      fetching,
      errorField,
    } = this.state;

    const {
      title = false,
      text = false,
      help = false,
      btn = false,
    } = getConfig({
      hasToken,
      isTokenValid,
      error,
      success,
      fetching,
    });
    return (
      <div className={className} data-testid="login-recover-form">
        {title && (
          <h2 className={this.getTitleClassNames(this.state)}>
            {t(`recover.${title}`)}
          </h2>
        )}

        <form
          className={`form ${errorField && 'form-error'}`}
          onSubmit={
            btn && isTokenValid
              ? this.handleSubmitReset
              : this.handleSubmitRequest
          }
        >
          {text && <p>{t(`recover.${text}`)}</p>}
          {help && <p>{t(`recover.${help}`)}</p>}

          {btn && !isTokenValid && (
            <Field
              id="credential"
              type="text"
              name="credential"
              onChange={this.setValue}
              label={t('recover.credential_label')}
              fullWidth
              value={credential}
              dataE2E="recover_credential"
              data-testid="recover_credential"
              disabled={fetching}
            />
          )}
          {isTokenValid && btn && (
            <div className="tax-data inspectlet-sensitive">
              <Field
                id="password"
                name="password"
                onChange={this.setValue}
                label={t('recover.password_label')}
                type="password"
                fullWidth
                value={password}
                dataE2E="recover_password"
              />
            </div>
          )}
          {btn && errorField && (
            <p className="error-field">
              {t(`recover.error_${!isTokenValid ? 'credential' : 'password'}`)}
            </p>
          )}

          {btn && (
            <DefaultButton
              id="submit"
              type="submit"
              size="L"
              text={t(`recover.${btn}`)}
              dataE2E="login_submit"
              data-testid="login_submit"
              disabled={fetching}
            />
          )}
        </form>
      </div>
    );
  }
}

LoginRecoverForm.propTypes = {
  className: PropTypes.string.isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  t: PropTypes.func,
  login: PropTypes.func,
};

LoginRecoverForm.defaultProps = {
  t: (t) => t,
  match: {},
  login: () => ({}),
};

export default LoginRecoverForm;
